import { createContext, use } from 'react';

const context = createContext(false);

export function IsTabProvider({ children }: { children: React.ReactNode }) {
	return <context.Provider value={true}>{children}</context.Provider>;
}

export default function useIsTab(): boolean {
	return use(context);
}
